export interface FaqItem {
  id: number;
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    id: 1,
    question: '建站需要懂编程吗？',
    answer: '完全不需要！我们的平台采用可视化拖拽编辑器，所有操作都是点击和拖拽完成的。即使你没有任何编程基础，也能在几分钟内搭建出一个专业的网站。就像使用Word文档一样简单。',
  },
  {
    id: 2,
    question: '免费版有什么限制吗？',
    answer: '免费版包含了建站所需的核心功能：2000+精美模板、拖拽编辑器、响应式设计、基础SEO工具等。你可以完整地搭建和发布一个网站。升级付费版可以解锁更多高级功能，如自定义域名绑定、电商功能、高级分析工具等。',
  },
  {
    id: 3,
    question: '网站能在手机上正常显示吗？',
    answer: '当然可以！我们平台上的所有模板都经过了响应式设计优化，会自动适配手机、平板和电脑等不同尺寸的屏幕。你还可以在编辑器中切换到移动端预览模式，实时查看和调整手机端的显示效果。',
  },
  {
    id: 4,
    question: '可以绑定我自己的域名吗？',
    answer: '付费版用户可以将自己购买的域名绑定到网站上。我们提供了详细的域名绑定教程，整个过程只需要几分钟。如果你还没有域名，也可以通过我们的平台直接购买。',
  },
  {
    id: 5,
    question: '我的网站数据安全吗？',
    answer: '非常安全。我们使用全球顶级的云服务商提供托管服务，所有网站都默认启用了SSL加密证书（HTTPS），确保数据传输过程中的安全性。同时我们定期进行数据备份，防止数据丢失。',
  },
  {
    id: 6,
    question: '网站对搜索引擎友好吗？',
    answer: '是的，我们的平台内置了完善的SEO优化工具。你可以自定义每个页面的标题、描述和关键词，自动生成站点地图，添加结构化数据标记。所有模板的代码都遵循搜索引擎最佳实践，帮助你的网站获得更好的排名。',
  },
  {
    id: 7,
    question: '如果遇到问题，有客服支持吗？',
    answer: '我们提供7x24小时的技术支持服务。你可以通过在线客服、邮件或帮助中心找到答案。帮助中心有数千篇详细的图文教程和视频指南，覆盖了建站的各个方面。',
  },
  {
    id: 8,
    question: '之后可以更换模板吗？',
    answer: '可以随时更换。不过需要注意的是，更换模板后，你可能需要重新调整一些内容和布局设置。建议在建站之初多花些时间浏览模板库，选择一个最接近你理想设计的模板，减少后续调整的工作量。',
  },
];